export default "__VITE_ASSET__CjAnPijf__"